import React from 'react';
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/index.css';
import SpinnerCrimp from 'src/pages/components/utilities/SpinnerCrimp';
var selfStyles = require('./styles.scss');
var PageWait = function (props) { return (React.createElement(Layout.Content, { className: selfStyles.wrapper },
    React.createElement(SpinnerCrimp, { size: 'medium' }),
    props.waitMessage && React.createElement("span", { className: selfStyles.message }, props.waitMessage))); };
export default PageWait;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageWait/index.tsx
// module id = 749
// module chunks = 0